import { render, staticRenderFns } from "./FastService.vue?vue&type=template&id=fb3c82d2&scoped=true&"
import script from "./FastService.vue?vue&type=script&lang=js&"
export * from "./FastService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3c82d2",
  null
  
)

export default component.exports